import CryptoAES from 'crypto-js/aes'
import CryptoENC from 'crypto-js/enc-utf8';
import SECRET from "../../config/contants/secret";

const getAuthProfile = () => {
	return JSON.parse(localStorage.getItem("auth"))
}

const getAuthenticFlag = () => {
	return localStorage.getItem("authentic")
}

const getToken= () => {
	return localStorage.getItem("token")
}

const getClinicId= () => {
	return localStorage.getItem("clinic_id")
}

const getRememberPassword = () => {
	const data = JSON.parse(localStorage.getItem("rememberPassword"));
	if (data) {
		const decryptPassword = CryptoAES.decrypt(data.password, SECRET.SECRET_KEY);
		const newData = {
			...data,
			password: decryptPassword.toString(CryptoENC)
		}
		return newData;
	}
	return data;
}

export {
	getAuthProfile,
	getAuthenticFlag,
	getToken,
	getClinicId,
	getRememberPassword,
}
